import React from "react";
import PropTypes from "prop-types";
import TextBlock from "../text/TextBlock";

/**
 * NotesBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Image block renderer
 *
 * @param {*} props
 */
const NotesBlock = props => (
  <div>
    {!props.isReadOnlyMode ? null : (
      <TextBlock
        {...props}
        isReadOnlyMode={false}
        dataKey={"notes"}
        placeholder={"manuscript.blocks.notes.placeholder"}
      />
    )}
  </div>
);

NotesBlock.propTypes = {
  /**
   * block: {url}
   * Contains the content block information
   */
  block: PropTypes.shape({
    notes: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default NotesBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/layout/NotesBlock.js